// Veřejný vstupní bod SDK. Export tvoří stabilní veřejné API (§30).
// Interní knihovny (web-ifc/thatopen/three) se ven NEexportují (§24).
import { IFCViewer } from "./IFCViewer.js";
import { ErrorCode, ViewerError } from "./errors.js";
import { ViewerEvents } from "./events.js";
import { SDK_VERSION } from "./version.js";
import { startViewerBridge } from "./iframe-bridge.js";

// Auto-detekce adresáře skriptu pro výchozí cestu k web-ifc.wasm (classic <script>).
// Umožní `<script src=".../sdk/ifc-viewer-sdk.js">` bez ruční konfigurace wasm.
try {
  if (typeof document !== "undefined" && document.currentScript && document.currentScript.src) {
    const dir = document.currentScript.src.replace(/[^/]*$/, "");
    IFCViewer.defaultWasm = { path: dir, absolute: true };
  }
} catch (_) { /* ignore */ }

export { IFCViewer, ViewerError, ErrorCode, ViewerEvents, SDK_VERSION, startViewerBridge };
export default IFCViewer;
